import { Link } from 'react-router-dom';
import { actorList } from '@/mocks/actors';

export default function ActorSidebar() {
  const actors = actorList.slice(0, 6);

  return (
    <aside className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-background-200 bg-secondary-50">
        <span className="w-8 h-8 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
          <i className="ri-user-star-line"></i>
        </span>
        <h2 className="font-heading text-base font-bold text-foreground-950">热门演员动态</h2>
      </div>
      <div className="divide-y divide-background-200">
        {actors.map((actor) => (
          <div key={actor.id} className="flex gap-3 p-4">
            <div className="shrink-0 w-12 h-14 rounded-md overflow-hidden">
              <img src={actor.photo} alt={`演员 ${actor.name}`} title={`${actor.name} 演员动态`} className="w-full h-full object-cover object-top" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="font-heading text-sm font-bold text-foreground-950">{actor.name}</span>
                <span className="px-1.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-label whitespace-nowrap">
                  {actor.region}
                </span>
              </div>
              {actor.latestNews.map((news) => (
                <Link
                  key={`${actor.id}-${news.newsId}`}
                  to={`/detail/news/${news.newsId}`}
                  className="mt-1 block text-xs text-foreground-600 hover:text-primary-600 transition-colors line-clamp-2 cursor-pointer"
                >
                  {news.title}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 pt-0">
        <Link
          to="/category/actors"
          className="flex items-center justify-center gap-1 w-full py-2.5 rounded-md bg-secondary-500 text-background-50 dark:text-foreground-950 text-sm font-label font-medium hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部演员动态
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </aside>
  );
}